<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('employee.action')}`
          : `${$t('common.edit')} ${$t('employee.action')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col lg="4">
            <AutoComplete
              :label="$t('employee.employee')"
              :placeholder="`${$t('common.select')} ${$t('employee.employee')}`"
              v-model="EditForm.employee_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="employees"
              text-title="full_name"
            />
            <p class="text-danger mt-1">{{ errorForm.employee_id }}</p>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="$t('employee.amount')" label-for="Amount">
              <b-form-input
                id="Amount"
                type="number"
                v-model="EditForm.amount"
                :placeholder="$t('employee.amount')"
              />
              <p class="text-danger mt-1">{{ errorForm.amount }}</p>
            </b-form-group>
          </b-col>

          <b-col lg="4">
            <b-form-group :label="$t('common.date')" label-for="Date">
              <datepicker
                v-model="EditForm.date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                :disabled-dates="{
                  to: new Date(new Date().setDate(new Date().getDate() - 1)),
                }"
                placeholder="YYYY-MM-DD"
              ></datepicker>
              <p class="text-danger mt-1">{{ errorForm.date }}</p>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              :label="$t('common.description')"
              label-for="Description"
            >
              <b-form-input
                id="Description"
                v-model="EditForm.description"
                placeholder="Description"
              />
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group :label="$t('employee.action-type')" label-for="type">
              <v-select
                v-model="EditForm.action_type"
                :options="[
                  { text: $t('employee.deduction'), value: '0' },
                  { text: $t('employee.reward'), value: '1' },
                ]"
                :reduce="(action) => action.value"
                label="text"
                :placeholder="`${$t('common.select')} ${$t(
                  'employee.action-type'
                )}`"
              />
              <p class="text-danger mt-1">{{ errorForm.action_type }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('employee.salary-actions')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>
              {{ $t('common.filter') }} {{ $t('employee.salary-actions') }}
            </h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('employee.employee')"
              :placeholder="`${$t('common.select')} ${$t('employee.employee')}`"
              v-model="employeeFilter"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="employees"
              text-title="full_name"
            />
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('employee.action-type')" label-for="type">
              <v-select
                v-model="actionFilter"
                :options="[
                  { text: $t('employee.deduction'), value: '0' },
                  { text: $t('employee.reward'), value: '1' },
                ]"
                :reduce="(action) => action.value"
                label="text"
                :placeholder="`${$t('common.select')} ${$t(
                  'employee.action-type'
                )}`"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getSalaryActionsList()">
              {{ $t('common.search') }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t('common.table') }} {{ $t('employee.salary-actions') }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="$store.state.app.permissions.includes('store-salaryAction')"
          >
            {{ $t('common.create') }} {{ $t('employee.action') }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(amount)="data">
            <span>{{ data.item.amount }} {{ $t('employee.iqd') }}</span>
          </template>
          <template #cell(action_type)="data">
            <b-badge
              :variant="data.item.action_type == 0 ? 'danger' : 'success'"
            >
              {{
                data.item.action_type == 0
                  ? $t('employee.deduction')
                  : $t('employee.reward')
              }}</b-badge
            >
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                deletePerm="delete-salaryAction"
                editPerm="update-salaryAction"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.laoding')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
                {{ $t('employee.action') }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getSalaryActionsList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BBadge,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import permissionChecker from '@/mixins/permissionChecker';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BBadge,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    AutoComplete,
    Datepicker,
    vSelect,
    ActionsButtons,
    DeleteModal,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        amount: '',
        employee_id: '',
        description: '',
        date: '',
        action_type: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        amount: '',
        employee_id: '',
        description: '',
        date: '',
        action_type: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'employee.full_name',
          label: this.$t('employee.employee'),
          sortable: true,
        },
        {
          key: 'action_type',
          label: this.$t('employee.action-type'),
          sortable: true,
        },
        { key: 'amount', label: this.$t('employee.amount'), sortable: true },
        { key: 'date', label: this.$t('common.date'), sortable: true },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getSalaryActionsList();
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true;
        this.EditForm = {
          amount: '',
          employee_id: '',
          description: '',
          date: '',
          action_type: '',
          _method: 'POST',
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.amount = item.amount;
        this.EditForm.employee_id = item.employee_id;
        this.EditForm.description = item.description;
        this.EditForm.date = item.date;
        this.EditForm.action_type = item.action_type.toString();
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-edit');
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getSalaryActionsList() {
      this.loading = true;

      let url = `/salaryAction?page=${this.page}&take=${this.take}&sort=-id&include=employee`;

      if (this.employeeFilter) {
        url += `&filter[employee_id]=${this.employeeFilter}`;
      }
      if (this.actionFilter) {
        url += `&filter[action_type]=${this.actionFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    formatDate(actionDate) {
      // Create a new Date object from the selected date
      const date = new Date(actionDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = '' + (date.getMonth() + 1); // getMonth() is zero-based
      let day = '' + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/salaryAction/${this.deleteForm.id}`)
        .then((response) => {
          this.getSalaryActionsList();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.amount = '';
      this.errorForm.employee_id = '';
      this.errorForm.action_type = '';
      this.errorForm.date = '';
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.amount) {
        this.errorForm.amount = "The amount field is required.";
        count++;
      }

      if (!this.EditForm.employee_id) {
        this.errorForm.employee_id = "The employee field is required.";
        count++;
      }

      if (!this.EditForm.date) {
        this.errorForm.date = "The date field is required.";
        count++;  
      }

      if (!this.EditForm.action_type) {
        this.errorForm.action_type = "The action type field is required.";
        count++;
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      this.EditForm.date = this.formatDate(this.EditForm.date);
      this.EditForm.action_type = this.EditForm.action_type;
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/salaryAction`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.getSalaryActionsList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/salaryAction/${this.EditForm.id}`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              this.getSalaryActionsList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
